import { jsx as j } from "react/jsx-runtime";
import { useMemo as C, useCallback as u, useState as g, useEffect as E } from "react";
import { MultipleSelectWithOptionList as F } from "./addFilterPanel/MultipleSelectWithOptionList.js";
import "../../useResizeDetector-sfyDtky2.js";
import { useLanguageResolver as M } from "@biron-data/react-contexts";
const R = () => {
  const e = C(() => /[|\\{}()[\]^$+*?.-]/g, []), n = u((a) => {
    if (a && a !== "") {
      const t = a.replace(e, (o) => o === "*" ? ".*" : o === "?" ? "." : `\\${o}`);
      return new RegExp(`${t}`, "i");
    } else
      return null;
  }, [e]);
  return u((a, t) => {
    const o = n(t);
    return a.filter((r) => r.label && (!o || o.test(r.label.toLocaleLowerCase())));
  }, [n]);
}, O = ({
  filters: e,
  getOptions: n,
  placementOverride: a,
  onTemporaryFiltersChange: t,
  allowMultipleSelection: o,
  isSimpleInput: r,
  withBackground: w,
  getPopupContainer: v,
  getDefaultValue: m
}) => {
  const b = M(), [y] = g("top");
  E(() => {
    p(n(e));
  }, [n]);
  const [i, p] = g(n(e)), h = R(), L = u((d) => {
    p(h(n(e), d));
  }, [h, e, n]), $ = u((d, x) => {
    const c = Array.from(i), l = c.findIndex((s) => s.label === d.label);
    c[l] = {
      ...c[l],
      selected: x
    }, p(c);
    const f = Object.assign([], e);
    if (x) {
      const s = {
        dataType: i[l].type,
        reference: {
          code: c[l].value,
          alias: c[l].label
        },
        predicate: {
          ...m(),
          negate: !1
        },
        isValid: !0
      };
      f.push(s);
    } else
      f.splice(f.findIndex((s) => s.reference.alias === d.label), 1);
    t(f);
  }, [e, m, t, i]);
  return /* @__PURE__ */ j(
    F,
    {
      withBackground: w,
      isSimpleInput: r,
      placement: y,
      placeholder: {
        add: b.get("configuration-add-filter", !r),
        search: b.get("configuration-search-filter", !r)
      },
      placementOverride: a,
      options: i,
      onChange: $,
      allowMultipleSelection: o,
      noDataTextKey: "configuration-no-filter-available",
      getPopupContainer: v,
      onSearch: L
    }
  );
};
export {
  O as default
};
//# sourceMappingURL=FilterPopover.js.map
